import React, { forwardRef, ReactElement } from 'react';

import './ToggleButton.css';
import FormElemLabel from '../../../Blackbird/Forms/FormElement/FormElemLabel';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  testId: string;
  label?: string;
}

const ToggleButton = forwardRef<HTMLInputElement, Props>(
  ({ testId = 'toggle-button', label = '', ...rest }, ref): ReactElement<any> => {
    return (
      <div className="flex items-center">
        <label className="kobai-toggle-button ma-8-right">
          <input data-testid={testId} type="checkbox" {...rest} ref={ref} />
          <span className="kobai-toggle-button__slider --round"></span>
        </label>
        <FormElemLabel marginBottom={false}>{label}</FormElemLabel>
      </div>
    );
  }
);

export default ToggleButton;
